import { render, staticRenderFns } from "./ElectionsHeader.vue?vue&type=template&id=2268fa58&scoped=true"
import script from "./ElectionsHeader.vue?vue&type=script&lang=js"
export * from "./ElectionsHeader.vue?vue&type=script&lang=js"
import style0 from "./ElectionsHeader.vue?vue&type=style&index=0&id=2268fa58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268fa58",
  null
  
)

export default component.exports